export default __webpack_public_path__ + "bbcc8789ca161ac44145991daa1f5d0f.png";